import { Skeleton } from "primereact/skeleton";
import React from "react";
function ItemLoading() {
  return <Skeleton width="80px" height="20px"></Skeleton>;
}
export default ItemLoading;
